<template>
	<div class="navcontainer" style="z-index: 1200;"> 
			<nav class="nav"> 
				<div class="nav-upper-options"> 
					<div class="nav-option"> 
					<router-link  exact-active-class="active-link" class="btn option1" to="/"><i class="bi bi-speedometer"></i> Weather Dashboard</router-link> 
					</div> 



					<div class="nav-option"> 
					<router-link exact-active-class="active-link" class="btn option1" to="/devices"><i class="bi bi-cpu"></i> Devices</router-link> 
					</div> 



					<div class="nav-option"> 
					<router-link exact-active-class="active-link" class="btn option1" to="/weather-trends"><i class="bi bi-bar-chart"></i> Weather Trends</router-link> 
					</div> 


					<div class="nav-option"> 
					<router-link  exact-active-class="active-link"class="btn option1" to="/map"><i class="bi bi-map"></i> Map</router-link> 
					</div> 



					<div class="nav-option"> 
					<router-link  exact-active-class="active-link"class="btn option1" to="/notifications"><i class="bi bi-bell"></i> Notifications</router-link> 
					</div> 








					
				</div> 
			</nav> 
		</div>
</template>


<script>
	export default{

		name : 'sidebar',

		methods : {
			logout(){
				this.$router.push('/sudo')
			}
		}

	}

</script>